<template>
  <div id="calendar-appointment" :class="{'is-full-screen': full_screen}" v-if="config.appointment_feature == 1">
    <vx-card id="calendar-card">
      <div class="flex justify-between pt-1">
        <div class="flex justify-start">
          <vs-dropdown
            vs-trigger-click
            class="btn-dropdown-calendar staff-button rounded-item cursor-pointer"
            style="z-index: 101; position: relative"
          >
            <!-- <a href.prevent v-if="selectedResource"> -->
            <a href.prevent v-if="selectedResource && selectedResource.length">
              <!-- <div
                style="
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  min-width: 5px;
                  position: absolute;
                  top: 50%;
                  left: 7px;
                  transform: translateY(-50%);
                "
                :style="`background: ${
                  selectedResource.color_code
                    ? selectedResource.color_code
                    : '#2979FF'
                }`"
              ></div> -->
              <div
                style="
                  width: 6px;
                  height: 6px;
                  border-radius: 50%;
                  min-width: 5px;
                  position: absolute;
                  top: 50%;
                  left: 7px;
                  transform: translateY(-50%);
                "
                :style="`background: ${
                  selectedResource[0] && selectedResource[0].color_code ? selectedResource[0].color_code : '#2979FF'
                }`"
              ></div>
              <div
                class="
                  calendar-resource
                  border-left-custom
                  calendar-staff-filter
                "
              >
                <!-- {{ selectedResource.title }} -->
                <template v-if="selectedResource.length > 1">
                  {{ selectedResource.length }} Staffs
                </template>
                <template v-else>
                  {{ selectedResource[0].title }}
                </template>
                <vs-icon class icon="expand_more"></vs-icon>
              </div>
            </a>
            <!-- <div class v-else> -->
            <a class="pr-4" href.prevent v-else>
              Staffs
              <vs-icon class icon="expand_more"></vs-icon>
            </a>
            <!-- </div> -->
            <vs-dropdown-menu class="staff-filter-dropdown-menu">
              <span>
                <vs-dropdown-item @click="selectSource()"
                  >Show all</vs-dropdown-item
                >
              </span>
              <span v-for="resource in resourceFilter" :key="resource.id">
                <vs-dropdown-item @click="selectSource(resource)">
                  <div class="flex align-center">
                    <div
                      class="mx-2"
                      style="
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                        min-width: 8px;
                      "
                      :style="`background: ${
                        resource.color_code ? resource.color_code : '#2979FF'
                      }`"
                    ></div>
                    <div
                      class="
                        calendar-resource
                        text-left
                        border-left-custom
                        py-1
                        flex
                        justify-between
                      "
                    >
                      {{ resource.title }}
                      <feather-icon icon="CheckIcon" svgClasses="w-5 h-5 stroke-current text-primary ml-3" v-if="selectedResource.find(item => item.id == resource.id)" />
                    </div>
                  </div>
                </vs-dropdown-item>
              </span>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-dropdown
            vs-trigger-click
            class="btn-dropdown-calendar no-border-dropdown cursor-pointer"
            style="z-index: 101"
          >
            <a class="btn-calendar" href.prevent>
              Filter
              <vs-icon class icon="expand_more"></vs-icon>
            </a>
            <vs-dropdown-menu>
              <vs-dropdown-item>
                <div
                  class="calendar-resource text-left"
                  @click="selectFilter('scheduled')"
                >
                  <vs-checkbox v-model="filter_scheduled"
                    >Scheduled</vs-checkbox
                  >
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <div
                  class="calendar-resource text-left"
                  @click="selectFilter('confirmed')"
                >
                  <vs-checkbox v-model="filter_confirmed"
                    >Confirmed</vs-checkbox
                  >
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <div
                  class="calendar-resource text-left"
                  @click="selectFilter('done')"
                >
                  <vs-checkbox v-model="filter_done">Done</vs-checkbox>
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <div
                  class="calendar-resource text-left"
                  @click="selectFilter('canceled')"
                >
                  <vs-checkbox v-model="filter_canceled">Canceled</vs-checkbox>
                </div>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span
                  class="calendar-resource text-left"
                  @click="selectFilter('clear')"
                >
                  <div>Reset filter</div>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <div v-if="$route.query.app != 1" class="btn-calendar">
            <feather-icon
              v-if="full_screen == false"
              icon="MaximizeIcon"
              svgClasses="h-6 w-6 text-primary cursor-pointer"
              style="transform: translateY(1px); z-index: 101"
              @click.stop="toggleFullScreen"
            />
            <feather-icon
              v-if="full_screen == true"
              icon="MinimizeIcon"
              svgClasses="h-6 w-6 text-primary cursor-pointer"
              style="transform: translateY(1px); z-index: 101"
              @click.stop="toggleFullScreen"
            />
          </div>
        </div>
        <!-- <vs-button
        class="btn-calendar"
        @click="popupAddNew"
        id="add-new-btn"
        style="z-index: 101"
      >Add new</vs-button>

      <vs-button
        class="btn-calendar"
        @click="popupBlockTime"
        id="add-new-btn"
        style="z-index: 101"
        >Block time</vs-button>-->
        <div class="flex justify-end">
          <vs-button class="gradient gradient-primary no-shadow px-4 py-3 export-btn" style="z-index: 101" v-if="currentView.value == 'dayGridMonth'" @click="exportAppointment">
            <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
            Export
          </vs-button>
          <vs-dropdown
            vs-trigger-click
            class="btn-dropdown-calendar no-border-dropdown cursor-pointer"
            id="calendar-view-btn"
            style="z-index: 101"
          >
            <a class="btn-calendar" href.prevent>
              View by {{ currentView.name }}
              <vs-icon class icon="expand_more"></vs-icon>
            </a>
            <vs-dropdown-menu class="calendar-btn">
              <vs-dropdown-item
                v-if="this.currentView.value != 'listWeek'"
                @click="changeView('listWeek', 'List', '1w')"
                >List</vs-dropdown-item
              >
              <vs-dropdown-item
                v-if="this.currentView.value != 'resourceTimeGridDay'"
                @click="changeView('resourceTimeGridDay', 'Day', '1d')"
                >Day</vs-dropdown-item
              >
              <vs-dropdown-item
                v-if="this.currentView.value != 'timeGridThreeDay'"
                @click="changeView('timeGridThreeDay', '3 days', '3d')"
                >3 days</vs-dropdown-item
              >
              <vs-dropdown-item
                v-if="this.currentView.value != 'timeGridWeek'"
                @click="changeView('timeGridWeek', 'Week', '1w')"
                >Week</vs-dropdown-item
              >
              <vs-dropdown-item
                v-if="this.currentView.value != 'dayGridMonth'"
                @click="changeView('dayGridMonth', 'Month', '1m')"
                >Month</vs-dropdown-item
              >
            </vs-dropdown-menu>
          </vs-dropdown>

          <vs-button
            @click="popupAddNew(null, null)"
            style="z-index: 101; padding: 10px; font-size: 0.9em"
            >New Appointment</vs-button
          >
          <!-- <vs-dropdown
            vs-trigger-click
            class="btn-dropdown-calendar"
            id="add-new-btn"
            style="z-index: 101;"
          >
            <vs-button class="btn-calendar gradient gradient-primary no-shadow">
              Add new
              <vs-icon class icon="expand_more"></vs-icon>
            </vs-button>
            <vs-dropdown-menu class="calendar-btn-add-new">
              <vs-dropdown-item @click="popupAddNew">New Appointment</vs-dropdown-item>
              <vs-dropdown-item @click="popupBlockTime">New Blocked Time</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->
        </div>
      </div>
      <!-- <div id="div-with-loading" class="vs-con-loading__container"> -->
      <div class="position-relative" id="my-relative-calendar" :class="{'no-horizontal-scroll' : (resources && resources.length < show_scroll_staff_quantity)}">
        <datepicker
          class="my-input-calendar"
          v-model="currentDate"
          @selected="selectedDatePicker"
        ></datepicker>
        <FullCalendar
          id="div-with-loading"
          class="vs-con-loading__container"
          name="fullcalendar"
          defaultView="resourceTimeGridDay"
          :plugins="calendarPlugins"
          :header="calendarHeader"
          :customButtons="calendarCustomButtons"
          :weekends="true"
          @dateClick="handleDateClick"
          :views="views"
          :nowIndicator="true"
          :events="events"
          :businessHours="businessHours"
          @eventClick="handleEventClick"
          :editable="editable"
          :droppable="editable"
          @eventDrop="handleEventDrop"
          :eventDurationEditable="false"
          :datesRender="datesRender"
          :resources="resources"
          resourceOrder="index"
          :slotEventOverlap="false"
          :resourceEventOverlap="false"
          :selectOverlap="false"
          :eventOverlap="false"
          :allDaySlot="false"
          :minTime="minTime"
          :maxTime="maxTime"
          :slotDuration="slotTime"
          slotLabelInterval="01:00:00"
          aspectRatio="1.68"
          :scrollTime="scrollNow"
          nextDayThreshold="03:00:00"
          ref="calendar"
          style="transform: translateY(-40px); z-index: 100"
          @eventMouseEnter="handleEventMouseEnter"
          @eventMouseLeave="handleEventMouseLeave"
          :eventRender="handleEventRender"
          :class="{/*'list-month-view' : (currentView.value != 'timeGridThreeDay' && 
                                       currentView.value != 'resourceTimeGridDay' && 
                                       currentView.value != 'timeGridWeek')*/}"
        />
      </div>
      <!-- </div> -->
    </vx-card>
    <appointment-popup
      :config="popupConfig"
      @closePopup="closePopup"
      @edit="editAppointment"
      @copy="copyAppointment"
      :key="popupConfig.appointmentId + popupConfig.key"
    />
    <appointment-edit-popup
      v-if="popupEditConfig.isActive"
      :config="popupEditConfig"
      @closePopup="closeEditPopup"
      :key="popupEditConfig.key"
    />
    <block-time-popup
      :config="popupBlockTimeConfig"
      @closePopup="closeBlockTimePopup"
      :key="popupBlockTimeConfig.key"
    />
    <vs-prompt
      title="Confirmation"
      @accept="acceptAlert"
      :active.sync="activePrompt"
      accept-text="Continue"
      color="success"
      cancel-text="Delete"
      @cancel="deleteAlert"
    >
      <div class="con-exemple-prompt">{{ promptContent }}</div>
    </vs-prompt>
    <!-- <vs-prompt
      title="Confirmation"
      @accept="acceptUpdateEvent"
      :active.sync="activeUpdateEventPrompt"
      accept-text="Continue"
      color="success"
      cancel-text="Cancel"
      @cancel="cancelUpdateEvent"
    >
      <div class="con-exemple-prompt">{{ updateEventPromptContent }}</div>
    </vs-prompt> -->

    <search-appointment-popup
      :searchAppointmentConfig="searchAppointmentConfig"
    ></search-appointment-popup>
  </div>
  <div v-else-if="config.appointment_feature == 0">
    <vx-card>
      <h2>
        This is for Go Booking full version, please contact us for more info at
        <b>832-968-6668</b>
      </h2>
    </vx-card>
  </div>
  <custom-spinner v-else></custom-spinner>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import listPlugin from "@fullcalendar/list";
import AppointmentPopup from "./AppointmentPopup";
import AppointmentEditPopup from "./AppointmentEditPopup";
import BlockTimePopup from "./BlockTimePopup";
import moment from "moment";
import { EventSourcePolyfill } from "event-source-polyfill";
import { domain, client_id } from "../../axios";
import { formatExportDateString } from '../../helper/datetimeHelper';
import * as md5 from "md5";
import SearchAppointmentPopup from "./SearchAppointmentPopup";
import Datepicker from "vuejs-datepicker";
import FileDownload from'js-file-download';

export default {
  components: {
    FullCalendar,
    AppointmentPopup,
    AppointmentEditPopup,
    BlockTimePopup,
    SearchAppointmentPopup,
    Datepicker,
  },
  props: {
    dataChange: {
      type: Object,
    },
    searchAppointmentConfig: {
      type: Object,
    },
  },
  created() {
    const obj = {
      key: "config.appointment.show_scroll_staff_quantity"
    }
    this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
      let data = this.$store.getters["appSetting/keyStorage"];
      this.show_scroll_staff_quantity = data.value;
    }).catch(() => {
      const obj = {
        key: 'config.appointment.show_scroll_staff_quantity',
        value: 15
      }
      this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj);
    })

    this.subscribeTopic();
    this.$store.dispatch("service/GET_SERVICE_LIST");
    this.$store.dispatch("staff/GET_STAFF_LIST");
    this.$store.dispatch("customer/GET_CUSTOMER_LIST");
    this.$store.dispatch("business/GET_WORKING_HOUR", { business_id: 1 });
    if(this.$mqttClient) {
      // this.doSubscribe();
      this.$mqttClient.on("message", (topic, message) => {
        // console.log(`Received message ${message} from topic ${topic}`);
        if(message && topic == this.subscription.topic) {
          this.$store.dispatch("appointment/RELOAD_CALENDAR");
        }
      })
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.setPositionOfMiniCalendar();
    // }, 1000)
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.setCalendarWidth();
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler() {
        if(this.config && this.config.mqtt && this.subscribeSuccess == false) {
          this.subscription = {
            topic: `/gci/${this.config.mqtt.id}/appointment/update`,
            qos: 0,
          };
          this.doSubscribe();
        }
      }
    },
    // config: {
    //   immediate: true,
    //   deep: true,
    //   handler() {
    //     if(this.config && this.config.appointment_feature != 0 && this.config.appointment_feature != 1) {
    //       this.openLoadingInDiv();
    //     } else {
    //       this.closeLoading();
    //     }
    //   }
    // },
    dataChange: {
      immediate: true,
      deep: true,
      handler: function () {
        // if(this.dataChange) {
        //   console.log(this.dataChange.message);
        // }
        // if(this.dataChange && this.dataChange.message == 'afterInsert') {
        if (this.dataChange.message != "") {
          this.$store.dispatch("service/GET_SERVICE_LIST");
          this.$store.dispatch("staff/GET_STAFF_LIST");
          this.$store.dispatch("customer/GET_CUSTOMER_LIST");
          this.$store.dispatch("business/GET_WORKING_HOUR", { business_id: 1 });
          this.$store.dispatch("appointment/RELOAD_CALENDAR");
        }
      },
    },
    $route: {
      handler: function (route) {
        // console.log(route);
        if (route.params.id) {
          this.closePopup();
          this.$store
            .dispatch("appointment/GET_APPOINTMENT_DETAIL", {
              id: route.params.id,
            })
            .then(() => {
              this.openDetailPopup(route.params.id);
            })
            .catch((error) => {
              this.$vs.dialog({
                color: "danger",
                title: "Appointment detail",
                text: error,
                acceptText: "OK",
              });
            });
        }
      },
      deep: true,
      immediate: true,
    },
    myWindowWidth: {
      immediate: true,
      handler() {
        if (this.full_screen) {
          let navbar = document.getElementById("my-navbar-container");
          let my_vertical_nav_menu = document.getElementById(
            "my-vertical-nav-menu"
          );
          let content_area = document.getElementById("content-area");
          let router_view = document.getElementById("my-router-view");
          let router_content = document.getElementById("my-router-content");

          navbar.classList.add("d-none");
          my_vertical_nav_menu.classList.add("d-none");
          content_area.classList.add("m-0");
          router_view.classList.add("p-0");
          router_content.classList.add("mt-0");
        }
        this.setPositionOfMiniCalendar();
      },
    },
    change_date_value_key: {
      immediate: true,
      handler() {
        this.setPositionOfMiniCalendar();
      },
    },
    selectedResource: {
      immediate: true,
      deep: true,
      handler() {
        this.setCalendarWidth();
      }
    },
    currentView: {
      immediate: true,
      deep: true,
      handler() {
        this.setCalendarWidth();
      }
    }
    // currentDate: {
    //   immediate: true,
    //   handler() {
    //     console.log(this.currentDate);

    //   }
    // }
  },
  data() {
    let format_export_date_string = formatExportDateString();
    let full_screen = false;
    if (this.$route.query.app == 1) {
      full_screen = true;
    }
    return {
      //Config for edit popup
      popupEditConfig: {
        isActive: false,
        isNewEvent: true,
        appointmentId: null,
        initDate: null,
        key: 0,
        staff_id: null,
      },
      //Config for information popup
      popupConfig: {
        isActive: false,
        appointmentId: null,
        key: 10000,
      },
      popupCopyConfig: {
        isActive: false,
        isNewEvent: true,
        appointmentId: null,
        initDate: null,
        key: 0,
        staff_id: null,
      },
      popupBlockTimeConfig: {
        isActive: false,
        key: 30000,
      },
      calendarPlugins: [
        dayGridPlugin,
        resourceTimelinePlugin,
        interactionPlugin,
        timeGridPlugin,
        resourceTimeGridPlugin,
        listPlugin,
      ],
      calendarHeader: {
        left: "",
        center: "prev,today,title,next",
        right: "",
      },
      views: {
        timeGridThreeDay: {
          type: "timeGrid",
          duration: { days: 3 },
          buttonText: "3 day",
          slotEventOverlap: false,
        },
        dayGridMonth: {
          eventLimit: 4,
        },
        timeGridWeek: {
          slotEventOverlap: false,
        },
        resourceTimeGridDay: {
          titleFormat: {
            weekday: "short",
            year: "numeric",
            month: "short",
            day: "numeric",
          },
        },
      },
      currentView: {
        name: "Day",
        value: "resourceTimeGridDay",
      },
      calendarCustomButtons: {},
      scrollNow: moment().add("-2", "hours").format("HH:00:00"),
      activePrompt: false,
      promptContent: "",
      promptEvent: {},
      argPopup: null,
      filter_scheduled: true,
      filter_confirmed: true,
      filter_canceled: false,
      filter_done: true,
      string_params: "",
      full_screen,
      interval: null,
      lastAppointment: null,
      myWindowWidth: 0,
      currentDate: new Date(),
      change_date_value_key: 0,
      editable: true,
      isOpenLoading: false,
      show_scroll_staff_quantity: 15,
      subscription: {
        topic: "/gci/{id}/appointment/update",
        qos: 0,
      },
      subscribeSuccess: false,
      format_export_date_string
      // activeUpdateEventPrompt: false,
      // updateEventPromptContent: ""
    };
  },
  computed: {
    events() {
      return this.$store.getters["appointment/filteredList"];
    },
    resources() {
      return this.$store.getters["appointment/resourceList"];
    },
    resourceFilter() {
      return this.$store.getters["appointment/resourceFilter"];
    },
    businessHours() {
      if (this.$store.getters["business/workingHour"] != null) {
        return this.$store.getters["business/workingHour"].working_hour;
      } else {
        return [];
      }
    },
    selectedResource() {
      return this.$store.getters["appointment/selectedResource"];
    },
    appointmentDetail() {
      return this.$store.getters["appointment/appointmentDetail"];
    },
    config() {
      return this.$store.getters["auth/config"];
    },
    slotTime() {
      let minutes = parseInt(
        this.$store.getters["auth/config"].calendar_split_time
      );
      if (isNaN(minutes)) {
        minutes = 15;
      }
      return minutes * 60000;
    },
    minTime() {
      if (this.currentView.value == "timeGridWeek" || this.currentView.value == "timeGridThreeDay") {
        return "06:00:00";
      }
      if(this.config && !this.config.default_business_work_hour) {
        let data = this.businessHours;
        if (data && data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].daysOfWeek && data[i].daysOfWeek[0] == moment(this.currentDate).day()) {
              // return data[i].startTime;
              let time = moment(data[i].startTime, 'HH:mm:ss');
              let before_time = moment(time).add("-1", "hours");
              
              let result = before_time.format("HH:mm:ss");
              
              if ((time.hours() * 60 + time.minutes()) < before_time.hours() * 60 + before_time.minutes()) {
                result = "00:00:00";
              }
  
              return result;
            }
          }
        }
      }
      return "06:00:00";
    },
    maxTime() {
      if (this.currentView.value == "timeGridWeek" || this.currentView.value == "timeGridThreeDay") {
        return "22:00:00";
      }
      if(this.config && !this.config.default_business_work_hour) {
        let data = this.businessHours;
        if (data && data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            if (data[i].daysOfWeek && data[i].daysOfWeek[0] == moment(this.currentDate).day()) {
              // return data[i].endTime;
              let time = moment(data[i].endTime, 'HH:mm:ss');
              let after_time = moment(time).add("1", "hours");
              
              let result = after_time.format("HH:mm:ss");
              
              if ((time.hours() * 60 + time.minutes()) > after_time.hours() * 60 + after_time.minutes()) {
                result = "24:00:00";
              }
              
              return result;
            }
          }
        }
      }
      return "22:00:00";
    }
  },
  methods: {
    doSubscribe() {
      const { topic, qos } = this.subscription;
      this.$mqttClient.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          console.log("Subscribe to topics error", error);
          return;
        }
        this.subscribeSuccess = true;
        console.log("Subscribe to topics res", res);
      });
    },
    doUnSubscribe() {
      const { topic } = this.subscription;
      // this.client.unsubscribe(topic, (error) => {
      this.$mqttClient.unsubscribe(topic, (error) => {
        this.subscribeSuccess = false;
        if (error) {
          console.log("Unsubscribe error", error);
        }
      });
    },
    setCalendarWidth() {
      // return 0;
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.loadTime = setTimeout(() => {
        // let resources_length = this.resources && this.resources.length > 0 ? this.resources.length : 0;
        let columns = document.querySelectorAll('.fc-head-container.fc-widget-header .fc-resource-cell');
        let elem = document.querySelector('#calendar-appointment .fc-view > table');
        if(columns && elem) {
          let column_width = columns[0] ? columns[0].clientWidth : 0;
          // if(this.selectedResource) {
          if(this.selectedResource.length) {
            column_width = 0;
          }
          // let minViewWidth = 45 + 25 + resources_length * (column_width + 1);
          let minViewWidth = 45 + columns.length * (column_width + 1);
          elem.style.width = minViewWidth + 'px';
        }
      }, 2500);
    },
    openLoadingInDiv() {
      this.$vs.loading({
        container: "#app",
        scale: 0.8,
      });
      if (this.loadTime) {
        clearTimeout(this.loadTime);
        this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout(() => {
        if (this.isOpenLoading) {
          this.closeLoading();
          this.$vs.dialog({
            color: "danger",
            title: "Notification",
            text: "Get data failed",
            acceptText: "OK",
          });
        }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close("#app > .con-vs-loading");
      this.isOpenLoading = false;
    },
    onResize() {
      this.myWindowWidth = window.innerWidth;
      this.setPositionOfMiniCalendar();
    },
    setPositionOfMiniCalendar() {
      let elem = document.querySelector("#div-with-loading h2");
      let my_input = document.querySelector(".my-input-calendar");
      if (elem && my_input) {
        let calendar = document.querySelector("#div-with-loading");
        let calendar_pos = calendar.getBoundingClientRect();
        let elem_pos = elem.getBoundingClientRect();
        my_input.style.width = elem.clientWidth + "px";
        my_input.style.left = elem_pos.left - calendar_pos.left + "px";
      }
    },
    toggleFullScreen() {
      let navbar = document.getElementById("my-navbar-container");
      let my_vertical_nav_menu = document.getElementById(
        "my-vertical-nav-menu"
      );
      let content_area = document.getElementById("content-area");
      let router_view = document.getElementById("my-router-view");
      let router_content = document.getElementById("my-router-content");

      if (!this.full_screen) {
        this.full_screen = true;
        navbar.classList.add("d-none");
        my_vertical_nav_menu.classList.add("d-none");
        content_area.classList.add("m-0");
        router_view.classList.add("p-0");
        router_content.classList.add("mt-0");
      } else {
        this.full_screen = false;
        navbar.classList.remove("d-none");
        my_vertical_nav_menu.classList.remove("d-none");
        content_area.classList.remove("m-0");
        router_view.classList.remove("p-0");
        router_content.classList.remove("mt-0");
      }
    },
    // dayRenderCallback() {
    //   setTimeout(
    //     () =>
    //       this.$el.querySelector("h2").addEventListener("click", () => {
    //         this.openDatePicker();
    //       }),
    //     0
    //   );
    //   console.log();
    // },
    // openDatePicker() {
    //   console.log("open date picker");
    // },
    selectedDatePicker(date) {
      let calendarApi = this.$refs.calendar.getApi();
      calendarApi.gotoDate(date);
    },
    async handleDateClick(arg) {
      let calendarApi = this.$refs.calendar.getApi();
      if (calendarApi.view.type == "dayGridMonth") {
        calendarApi.gotoDate(arg.date);
        this.changeView("resourceTimeGridDay", "Day", "1d");
        return;
      }
      if (moment().format("X") > moment(arg.date).format("X")) {
        return;
      }
      if (arg.jsEvent.target.classList.contains("fc-nonbusiness")) {
        console.log("You've clicked outside business hour");
        this.$vs.dialog({
          color: "primary",
          title: "Appointment booking",
          text: "Can not schedule appointments outside your normal business hours!",
          acceptText: "OK",
        });
      } else if (arg.jsEvent.target.classList.contains("fc-bgevent")) {
        return;
      } else {
        await this.$vs.loading({
          container: "#div-with-loading",
          scale: 0.8,
        });
        this.argPopup = arg;
        this.$store
          .dispatch("appointment/GET_APPOINTMENT_SPECIFIC_DATE", {
            date: moment(arg.date).format("YYYY-MM-DD"),
          })
          .then(() => {
            this.popupAddNew(arg);
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          });
      }
    },
    async handleEventClick(target) {
      if (target.event.rendering == "background") {
        if (target.event.extendedProps.service_id != null) {
          this.openConfirmBlockTime(target.event);
        } else {
          this.openBlockTimeAlert(target.event);
        }
      } else {
        await this.$vs.loading({
          container: "#div-with-loading",
          scale: 0.8,
        });
        this.$store
          .dispatch("appointment/GET_APPOINTMENT_DETAIL", {
            id: target.event.id,
          })
          .then(() => {
            this.$store
              .dispatch("appointment/GET_APPOINTMENT_SPECIFIC_DATE", {
                date: moment(target.event.start).format("YYYY-MM-DD"),
                appointment_id: target.event.id,
              })
              .then(() => {
                this.$vs.loading.close("#div-with-loading > .con-vs-loading");
                this.openDetailPopup(target.event.id);
              })
              .catch((error) => {
                console.log(error);
                this.$vs.loading.close("#div-with-loading > .con-vs-loading");
              });
          });
      }
    },

    handleEventDrop(target) {
      console.log(target);
      let oldResource = "";
      let newResource = "";
      if (target.oldResource != null && target.oldResource.title != null) {
        oldResource = target.oldResource.title;
      }
      if (target.newResource != null && target.newResource.title != null) {
        newResource = target.newResource.title;
      }

      let content =
        "Are you sure to update event from: " +
        moment(target.oldEvent.start).format("LLLL ") +
        (oldResource != "" ? "(" + oldResource + ")" : "") +
        " to: " +
        moment(target.event.start).format("LLLL ") +
        (newResource != "" ? "(" + newResource + ")" : "");
      ("?");
      this.$vs.dialog({
        color: "warning",
        title: `Confirmation!`,
        type: "confirm",
        text: content,
        accept: async () => {
          await this.$vs.loading({
            container: "#div-with-loading",
            scale: 0.8,
          });
          let data = {
            event: {
              id: target.event.extendedProps.child_appointment_id,
              start: moment(target.event.start).format("YYYY-MM-DD HH:mm:ss"),
              end:
                target.event.end != null
                  ? moment(target.event.end).format("YYYY-MM-DD HH:mm:ss")
                  : moment(target.event.start).format("YYYY-MM-DD HH:mm:ss"),
            },
            resource: target.newResource != null ? target.newResource.id : null,
          };
          this.$store
            .dispatch("appointment/DRAG_DROP_UPDATE", data)
            .then(() => {
              this.$vs.loading.close("#div-with-loading > .con-vs-loading");
            })
            .catch((error) => {
              console.log(error);
              target.revert();
              this.$vs.loading.close("#div-with-loading > .con-vs-loading");
            });
        },
        cancel: () => {
          target.revert();
        },
      });
    },

    handleEventMouseEnter(event) {
      if (event.jsEvent.target.classList.contains("fc-bgevent")) {
        console.log("");
      } else {
        if (
          event.el &&
          event.el.firstChild &&
          event.event.extendedProps.note &&
          event.jsEvent.sourceCapabilities.firesTouchEvents == false
        ) {
          event.el.style.zIndex = 100;
          if (!event.el.firstChild.classList.contains("show-tooltip")) {
            event.el.firstChild.classList = "show-tooltip";
            let my_tooltip = document.createElement("div");
            my_tooltip.setAttribute("id", "my-tooltip-id");
            my_tooltip.classList.add("custom-calendar-tooltip");
            my_tooltip.innerText = event.event.extendedProps.note;

            event.el.firstChild.append(my_tooltip);
          }
        }
      }
    },

    handleEventMouseLeave(event) {
      if (event.jsEvent != null) {
        if (event.jsEvent.target.classList.contains("fc-bgevent")) {
          console.log("bg event");
        } else {
          event.el.style.zIndex = 1;
          let my_tooltip = document.getElementById("my-tooltip-id");
          if (my_tooltip && my_tooltip.parentNode) {
            my_tooltip.parentNode.classList.remove("show-tooltip");
            my_tooltip.parentNode.removeChild(my_tooltip);
          }
        }
      }
    },

    handleEventRender(event) {
      this.setCalendarWidth();
      if (event.event.backgroundColor == "#FFFFFF") {
        event.el.classList.add("bg-colorful");
      }

      if (
        event.event.extendedProps.note &&
        event.event.extendedProps.note != ""
      ) {
        let note = document.createElement("img");
        note.src = "/note-icon.png";
        note.style =
          "width: 13px; height: 13px; position: absolute; bottom: 0; right: 0; padding: 2px; padding-left: 0;";
        event.el.appendChild(note);
      }

      // class cua event
      event.el.classList.add("custom_appointment");
      const requestEl = document.createElement('p');
      const highlightEl = document.createElement('p');
      const noShowEl = document.createElement('p');
      const checkInEl = document.createElement('p');
      const doneEl = document.createElement('p');
      const statusAppointment = document.createElement('div');
      statusAppointment.classList.add('status_appointment')
      requestEl.classList.add('status_item', 'status_request');
      requestEl.textContent = `Requested`;
      highlightEl.classList.add('status_highlight');
      highlightEl.innerHTML = `
        <svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 30L-8.74228e-07 10C-1.11564e-06 4.47715 4.47715 1.71165e-06 10 1.47023e-06L28 6.8343e-07L28 30L0 30Z" fill="#222222"/>
          <path d="M18.0131 16.7338L17.1998 15.8696C17.0064 15.6925 16.8931 15.4304 16.8864 15.14C16.8731 14.8213 16.9931 14.5025 17.2131 14.2688L18.0131 13.4188C18.7064 12.6821 18.9664 11.9738 18.7464 11.4142C18.5331 10.8617 17.8731 10.5571 16.8998 10.5571H9.93311V9.94794C9.93311 9.65752 9.70644 9.41669 9.43311 9.41669C9.15977 9.41669 8.93311 9.65752 8.93311 9.94794V23.0521C8.93311 23.3425 9.15977 23.5834 9.43311 23.5834C9.70644 23.5834 9.93311 23.3425 9.93311 23.0521V19.5954H16.8998C17.8598 19.5954 18.5064 19.2838 18.7264 18.7242C18.9464 18.1646 18.6931 17.4634 18.0131 16.7338Z" fill="#FFD055"/>
        </svg>
      `;
      noShowEl.classList.add('status_item', 'status_no_show');
      noShowEl.textContent = `No Show`;
      checkInEl.textContent = `Checked in`;
      checkInEl.classList.add('status_item', 'status_check_in')
      doneEl.textContent = `Done`;
      doneEl.classList.add('status_item', 'status_done')
      if(event.event.extendedProps.extra_data && JSON.parse(event.event.extendedProps.extra_data).request === 1) {
        statusAppointment.appendChild(requestEl);
      }
      if(event.event.extendedProps.extra_data && JSON.parse(event.event.extendedProps.extra_data).highlight === 1) {
        event.el.appendChild(highlightEl);
        event.el.style.border = '1px solid #000';
      }
      if(event.event.extendedProps.extra_data && JSON.parse(event.event.extendedProps.extra_data).no_show === 1) {
        statusAppointment.appendChild(noShowEl);
      }
      if (event.event.extendedProps.checkin_id) {
        statusAppointment.appendChild(checkInEl)
      }
      if (event.event.extendedProps.status === 'done') {
        statusAppointment.appendChild(doneEl)
      }
      event.el.querySelector('.fc-content') && event.el.querySelector('.fc-content').appendChild(statusAppointment);
    },

    openDetailPopup(id) {
      this.popupConfig = {
        appointmentId: id,
        isActive: true,
        key: this.popupConfig.key + 1,
      };
    },
    popupBlockTime() {
      this.popupBlockTimeConfig = {
        isActive: true,
        key: this.popupBlockTimeConfig.key + 1,
      };
    },
    popupAddNew(initDate = null, appointmentId = null, isCopy = false) {
      this.popupEditConfig.key = this.popupEditConfig.key + 1;
      this.popupEditConfig.isActive = true;
      this.popupEditConfig.isCopy = !!isCopy;
      if (appointmentId) {
        this.popupEditConfig.appointmentId = appointmentId;
        this.popupEditConfig.isEdit = true;
      } else {
        this.popupEditConfig.appointmentId = null;
        this.popupEditConfig.isEdit = false;
      }
      if (initDate) {
        this.popupEditConfig.initDate = initDate.date;
        if (initDate.resource != null) {
          this.popupEditConfig.staff_id = initDate.resource.id;
        } else if (
          initDate.dayEl &&
          initDate.dayEl.dataset.resourceId !== undefined
        ) {
          this.popupEditConfig.staff_id = initDate.dayEl.dataset.resourceId;
        }
      }
      if (initDate == null && appointmentId == null) {
        this.$store.dispatch("appointment/GET_APPOINTMENT_SPECIFIC_DATE", {
          date: moment().format("YYYY-MM-DD"),
        });
      }
    },
    closeEditPopup(data) {
      // this.openLoadingInDiv();
      if (data.appointment_id != null && data.appointment_id != false) {
        this.$store
          .dispatch("appointment/GET_APPOINTMENT_DETAIL", {
            id: data.appointment_id,
          })
          .then(() => {
            // this.closeLoading();
            this.openDetailPopup(data.appointment_id);
          });
      } else if (data.reopen == true) {
        // this.closeLoading();
        this.openDetailPopup(this.appointmentDetail.id);
      }
      this.popupEditConfig.isActive = false;
    },
    closePopup() {
      this.popupConfig.isActive = false;
    },
    closeBlockTimePopup() {
      this.popupBlockTimeConfig.isActive = false;
    },
    async changeView(type, name, range) {
      let calendarApi = this.$refs.calendar.getApi();
      this.currentView = {
        name: name,
        value: type,
        type: range,
      };
      if (
        this.currentView.value == "timeGridThreeDay" ||
        this.currentView.value == "resourceTimeGridDay" ||
        this.currentView.value == "timeGridWeek"
      ) {
        this.editable = true;
      } else {
        this.editable = false;
      }
      calendarApi.changeView(this.currentView.value);
    },
    // eslint-disable-next-line
    async datesRender(info) {
      let calendarApi = this.$refs.calendar.getApi();
      this.change_date_value_key++;
      await this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
      this.currentDate = calendarApi.view.currentStart;
      await this.$store
        .dispatch("appointment/RELOAD_CALENDAR", {
          type: this.currentView.type,
          start_time: moment(calendarApi.view.currentStart).format(
            "YYYY-MM-DD"
          ),
          status: this.string_params,
        })
        .then(() => {
          let isExist = false;
          // if (this.selectedResource != null) {
          if (this.selectedResource.length) {
            if (this.resources.length > 0) {
              for (let i = 0; i < this.resources.length; i++) {
                // if (this.resources[i].id == this.selectedResource.id) {
                //   isExist = true;
                //   break;
                // }
                for(let j = 0; j < this.selectedResource.length; j++) {
                  if (this.resources[i].id == this.selectedResource[j].id) {
                    isExist = true;
                    break;
                  }
                }
              }
            } else {
              this.selectSource();
            }
          }
          if (isExist == false) {
            this.selectSource();
          }
          setTimeout(() => {
            calendarApi.rerenderEvents();
            if (this.interval == null) {
              this.interval = setInterval(this.lastRecord, 10000);
            }
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
            this.setPositionOfMiniCalendar();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        });
    },
    editAppointment(id) {
      this.popupConfig.isActive = false;
      this.popupAddNew(null, id);
    },
    copyAppointment(id) {
      this.popupConfig.isActive = false;
      this.popupAddNew(null, id, true);
    },
    selectSource(item = null) {
      if (item != null) {
        this.$store.dispatch("appointment/SELECT_RESOURCE", item);
      } else {
        this.$store.dispatch("appointment/SELECT_RESOURCE");
      }
    },
    openConfirmBlockTime(event) {
      console.log('event: ', event);
      this.promptContent = this.selectedResource
        ? this.selectedResource.title
        : "This staff" +
          " is set up as busy at this time, do you still want to proceed? " +
          (event.extendedProps.note != ""
            ? "Note: " + event.extendedProps.note
            : "");
      this.activePrompt = true;
      this.promptEvent = event;
    },
    openBlockTimeAlert(event) {
      this.$vs.notify({
        title: "Alert",
        text:
          "Blocked with note: " +
          event.extendedProps.note +
          ', please navigate to "Block time setting" to remove it!',
        color: "warning",
        position: "top-right",
      });
    },
    acceptAlert() {
      let arg = {
        date: this.promptEvent.start,
        resource: {
          id: this.promptEvent._def.resourceIds[0]
            ? this.promptEvent._def.resourceIds[0]
            : null,
        },
      };
      this.$store
        .dispatch("appointment/GET_APPOINTMENT_SPECIFIC_DATE", {
          date: moment(this.promptEvent.start).format("YYYY-MM-DD"),
        })
        .then(() => {
          this.popupAddNew(arg);
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        })
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        });
    },
    deleteAlert() {
      let data = { id: this.promptEvent.id };
      this.$store
        .dispatch("appointment/DELETE_BLOCK_TIME", data)
        .then(() => {
          this.$vs.notify({
            title: "Success",
            text: "Deleted Block time successfully!",
            color: "success",
            position: "top-right",
          });
          this.closePopup();
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        })
        .catch(() => {
          this.$vs.notify({
            title: "Fail",
            text: "Delete Block time failed!",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        });
    },
    getDomain() {
      let temp = domain;
      if (domain[domain.length - 1] == "/") {
        temp = domain.slice(0, -1);
      }
      return temp.substring(temp.lastIndexOf("/") + 1);
    },
    subscribeTopic() {
      let topics = [
        "/v1/appointment",
        "/v1/appointment/appointment",
        "/v1/appointment/booking",
      ];
      let hubUrl = "";
      let jwt = "";
      if (process.env.NODE_ENV == "development") {
        hubUrl = process.env.VUE_APP_DEVELOPMENT_MERCURE_HUB_URL;
        jwt = process.env.VUE_APP_DEVELOPMENT_MERCURE_JWT;
      } else {
        let mercure = JSON.parse(localStorage.getItem("appMercure"));
        hubUrl = mercure.hub_url;
        jwt = mercure.jwt;
      }
      const option = {
        headers: {
          Authorization: "Bearer " + jwt,
        },
      };
      let id = md5(client_id);
      // console.log(id);

      const u = new URL(hubUrl);
      topics.forEach((topic) => {
        u.searchParams.append("topic", id + "/" + this.getDomain() + topic);
      });
      this.eventSource = new EventSourcePolyfill(u, option);
      this.eventSource.onmessage = (e) => {
        this.dataChange.message = JSON.parse(e.data);
        this.dataChange.key++;
        // console.log(this.dataChange)
      };
    },
    async selectFilter(type) {
      let calendarApi = this.$refs.calendar.getApi();
      await this.$vs.loading({
        container: "#div-with-loading",
        scale: 0.8,
      });
      switch (type) {
        case "scheduled": {
          this.filter_scheduled = !this.filter_scheduled;
          break;
        }
        case "confirmed": {
          this.filter_confirmed = !this.filter_confirmed;
          break;
        }
        case "done": {
          this.filter_done = !this.filter_done;
          break;
        }
        case "canceled": {
          this.filter_canceled = !this.filter_canceled;
          break;
        }
        case "clear": {
          this.filter_scheduled = true;
          this.filter_done = true;
          this.filter_confirmed = true;
          this.filter_canceled = false;
          break;
        }
      }
      this.string_params = "";

      if (
        this.filter_scheduled == false &&
        this.filter_confirmed == false &&
        this.filter_canceled == false &&
        this.filter_done == false
      ) {
        this.filter_scheduled = true;
        this.filter_done = true;
        this.filter_confirmed = true;
        this.filter_canceled = false;
      }

      if (this.filter_scheduled == true) {
        this.string_params += "scheduled,";
      }
      if (this.filter_confirmed == true) {
        this.string_params += "confirmed,";
      }
      if (this.filter_done == true) {
        this.string_params += "done,";
      }
      if (this.filter_canceled == true) {
        this.string_params += "canceled,";
      }
      if (this.string_params != "") {
        this.string_params = this.string_params.slice(0, -1);
      }

      await this.$store
        .dispatch("appointment/RELOAD_CALENDAR", {
          type: this.currentView.type,
          start_time: moment(calendarApi.view.currentStart).format(
            "YYYY-MM-DD"
          ),
          status: this.string_params,
        })
        .then(() => {
          setTimeout(() => {
            calendarApi.rerenderEvents();
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          }, 1000);
        })
        .catch(() => {
          calendarApi.rerenderEvents();
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        });
    },
    lastRecord() {
      if (typeof this.$refs.calendar !== "undefined") {
        let calendarApi = this.$refs.calendar.getApi();
        this.$store
          .dispatch("appointment/CHECK_UPDATE", {
            type: this.currentView.type,
            start_time: moment(calendarApi.view.currentStart).format(
              "YYYY-MM-DD"
            ),
            status: this.string_params,
          })
          .then((lastAppointment) => {
            if (lastAppointment) {
              if (this.lastAppointment == null) {
                this.lastAppointment = lastAppointment;
                this.$store.dispatch("appointment/RELOAD_CALENDAR");
                return;
              } else if (this.lastAppointment.id != lastAppointment.id || this.lastAppointment.updated_at != lastAppointment.updated_at) {
                this.$store.dispatch("appointment/RELOAD_CALENDAR");
              }
              this.lastAppointment = lastAppointment;
            }
          });
      } else {
        clearInterval(this.interval);
        this.interval = null;
        return;
      }
    },
    exportAppointment() {
      let obj = {
        date: moment(this.currentDate).format("YYYY-MM-DD")
      }
      this.$store.dispatch("appointment/EXPORT_APPOINTMENT", obj).then(res => {
        FileDownload(res.data, `#${localStorage.getItem("domainId")}-appointment-${moment().format(this.format_export_date_string)}.xls`);
        this.closeLoading();
        this.$vs.notify({
          title: "Notification",
          text: "Export Appointment Success",
          color: "success",
          position: "top-right"
        });
      });
    }
  },
  destroyed() {
    this.eventSource.close();
    clearInterval(this.interval);
    this.doUnSubscribe();
  },
};
</script>
